import { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function PayPalSuccess({
  cartItems,
  userId,
  name,
  email,
  phone,
  address1,
  address2,
  city,
  state,
  country,
  totalPrice,
  currency,
}) {
  const [loading, setLoading] = useState(true);
  const hasRun = useRef(false); // 👈 sadece bir kere çalışması için flag

  const navigate = useNavigate();

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    async function createOrderAfterPayment() {
      const orderData = JSON.parse(localStorage.getItem("order_info"));
      const conversionRate =
        parseFloat(localStorage.getItem("conversionRate")) || 1;

      if (!orderData || !orderData.cartItems) {
        Swal.fire("Hata", "Sipariş verisi bulunamadı.", "error");
        setLoading(false);
        return;
      }

      const {
        userId,
        name,
        email,
        phone,
        address1,
        address2,
        city,
        state,
        country,
        totalPrice,
        currency,
        cartItems,
      } = orderData;

      const paypalPaymentInfo = JSON.parse(
        localStorage.getItem("paypal_payment_info") || "{}"
      );
      const { price: paidPrice } = paypalPaymentInfo;

      const orderBody = {
        user_id: userId,
        name,
        email,
        total_price: paidPrice || totalPrice,
        currency: currency,
        status: "Pending",
        order_date: new Date().toISOString(),
        shipping_address: {
          phone,
          address1,
          address2,
          city,
          state,
          country,
        },
        order_items: cartItems.map((item) => {
          // Ürün fiyatını para birimine göre dönüştür
          const priceConverted =
            currency === "TRY" ? item.price : item.price / conversionRate;

          return {
            product_id: Number(item.id),
            product_name: item.name,
            quantity: Number(item.quantity),
            price: (Math.round(priceConverted * 1000) / 1000)
              .toFixed(3)
              .replace(/^0\.0*/, ""),
            color:
              item.selectedVariation?.name &&
              item.selectedVariation.name !== "Default"
                ? item.selectedVariation.name
                : item.attributes?.color || null,
            image_url:
              item.selectedVariation?.images?.[0] ||
              item.default_images?.[0] ||
              "/no-image.jpg",
          };
        }),
      };

      const orderRes = await fetch(`${process.env.REACT_APP_API_URL}/orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderBody),
      });

      const orderResult = await orderRes.json();

      if (orderResult.message === "Order created successfully") {
        const orderId = orderResult.id;
        Swal.fire(
          "Başarılı",
          "Siparişiniz başarıyla oluşturuldu.",
          "success"
        ).then(() => {
          localStorage.removeItem("paypal_payment_info");
          localStorage.removeItem("conversionRate"); // dilersen temizle
          navigate(`/order/${orderId}`);
        });
      } else {
        Swal.fire("Hata", "Sipariş oluşturulamadı.", "error");
      }

      setLoading(false);
    }

    createOrderAfterPayment();
  }, [navigate]);

  // if (loading) return <div>Ödeme ve sipariş işlemleri kontrol ediliyor...</div>;

  // return <div>İşlem tamamlandı.</div>;
  if (loading)
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 py-5 text-center">
              <div className="alert alert-warning" role="alert">
                Payment and order processes are being checked, please wait!
              </div>
            </div>
          </div>
        </div>
      </>
    );

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 py-5 text-center">
            <div className="alert alert-success" role="alert">
              Your payment has been received. Thank you for choosing us.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PayPalSuccess;
